import React from 'react';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from '@/app/hook';
import { selectClient } from '@/features/dashboard.slice';
import { WrappedErrorBoundary } from '@/pages/WrappedErrorBoundary';

import SessionsPieChart from './SessionsPieChart';

const ScenarioChatbotChart: React.FC = () => {
  const clientInfo = useAppSelector(selectClient);
  const { t } = useTranslation();

  const usedIA = clientInfo?.remainingSessions?.aiUsed || 0;
  const usedScenario = clientInfo?.remainingSessions?.scenarioUsed || 0;
  const usedTotal = usedIA + usedScenario;

  const sessionLimit = clientInfo?.remainingSessions?.sessionLimit || 0;

  const percentageFull = (100 * usedTotal) / (sessionLimit || 1); // avoid divide by zero

  return <SessionsPieChart used={usedTotal} limit={sessionLimit} title={t('Dashboard/scenario-bots')} percentageFull={percentageFull} />;
};

export default WrappedErrorBoundary(ScenarioChatbotChart);
